module.exports = __webpack_public_path__ + "static/media/border.a8b1bf37.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/border.svg
// module id = 321
// module chunks = 0